<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ImpInspDataForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImpInspDataForm from '@/components/organisms/terminal/form/ImpInspDataForm'

export default {
  name: 'ImpInspDataPage',

  components: {
    ImpInspDataForm,
  },
}
</script>
